import { useI18n } from "@/lib/i18n";

export default function ForWhom() {
  const { t } = useI18n();

  return (
    <section className="py-16 lg:py-20 bg-secondary">
      <div className="mx-auto max-w-container px-6 lg:px-10">
        <div className="max-w-prose mb-10 reveal">
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-3">
            {t.home.forWhomEyebrow}
          </div>
          <h2 className="font-serif text-[36px] lg:text-[44px] leading-[1.1] tracking-tight">
            {t.home.forWhomTitle}
          </h2>
          <p className="mt-3 text-lg text-muted-foreground leading-relaxed">
            {t.home.forWhomBody}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.home.cards.map(([title, body], i) => (
            <div key={title} className="reveal bg-background border border-border rounded-md p-7" style={{ transitionDelay: `${i * 60}ms` }}>
              <h3 className="font-serif text-xl mb-3">{title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
